"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.html = html;
exports.unsafeToHtml = unsafeToHtml;
exports.escapeHtml = escapeHtml;
exports.textForHtmlEmail = textForHtmlEmail;
/** Tagged template literal for creating HtmlString values from inline HTML. */
function html(strings, ...values) {
    return String.raw(strings, ...values);
}
/** Escape hatch for casting a dynamically-built HTML string. Use sparingly. */
function unsafeToHtml(value) {
    return value;
}
const HTML_ESCAPES = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
};
/**
 * Escapes text that is about to be interpolated into markup.
 *
 * Lives beside {@link unsafeToHtml} on purpose: that cast is only honest when
 * every dynamic value inside the string went through this first, so the two
 * belong in one place rather than one being a helper local to whichever template
 * happened to need it.
 */
function escapeHtml(text) {
    return text.replace(/[&<>"']/g, (char) => HTML_ESCAPES[char] ?? char);
}
/**
 * Converts plain-text newlines to HTML <br> for display in the SendGrid template.
 * Only use on plain-text content (e.g. NNR templates). Do NOT apply to HTML email
 * bodies — inserting <br> inside HTML tags breaks their structure.
 */
function textForHtmlEmail(body) {
    return body.replace(/\n/g, "<br>");
}
//# sourceMappingURL=htmlTypeSafety.js.map